/* ═══════════════════════════════════════════════════
   IMAGE ZOOM

   Click any element carrying [data-zoom] to open its image full-screen.
   The large version comes from data-zoom-src, which is rendered at a much
   higher width than the inline copy — the point is to make small text in a
   screenshot readable, and scaling up the thumbnail wouldn't do that.

   Deliberately no library: this is a few dozen lines and the theme already
   carries enough JavaScript.
   ═══════════════════════════════════════════════════ */

(function () {
  var overlay = null;
  var lastTrigger = null;

  function close() {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    /* Focus goes back where it came from, or someone navigating by keyboard is
       dumped at the top of the document with no idea where they are. */
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(trigger) {
    if (overlay) return;
    var src = trigger.getAttribute('data-zoom-src');
    if (!src) return;

    lastTrigger = trigger;

    overlay = document.createElement('div');
    overlay.className = 'fs-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', trigger.getAttribute('data-zoom-label') || 'Enlarged image');

    var img = document.createElement('img');
    img.className = 'fs-zoom__img';
    img.src = src;
    img.alt = trigger.getAttribute('data-zoom-label') || '';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fs-zoom__close';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = '&times;';

    overlay.appendChild(img);
    overlay.appendChild(btn);
    document.body.appendChild(overlay);

    /* Stops the page scrolling underneath the overlay on a phone. */
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    btn.focus();

    btn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      /* Clicking the image itself must not close it — people pinch and drag to
         read, and losing it mid-read is maddening. */
      if (e.target === overlay) close();
    });
  }

  /* One delegated listener on the document, so images added later — by the
     Theme Editor, or any section that adopts this — work with no extra wiring. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-zoom]') : null;
    if (trigger) open(trigger);
  });
})();
